export default __webpack_public_path__ + "static/media/charith kashyap.5ee271ec.jpg";